var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m464.1,67.7h-416.2c-19.8,0-36.4,15.6-36.4,36.4v303.8c0,19.8 15.6,36.4 36.4,36.4h416.1c19.8,0 36.4-16.6 36.4-37.4v-302.8c0.1-19.7-15.5-36.4-36.3-36.4zm16.6,339.1c0,9.4-7.3,16.6-16.6,16.6h-416.2c-9.4,0-16.6-7.3-16.6-16.6v-302.7c0-9.4 7.3-16.6 16.6-16.6h416.1c9.4,0 16.6,7.3 16.6,16.6v302.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,134.3H69.8v108.2H178V134.3z M158.2,222.7H90.6v-67.6h67.6V222.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 215.3,
    x: 80.2,
    y: 294.5,
    height: 20.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 215.3,
    x: 80.2,
    y: 360,
    height: 20.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.1210b6c5.svg";
export { ForwardRef as ReactComponent };